
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { ViewService } from "@/services/view-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppSearchSettingsEdit from "./SearchSettingsEdit.vue";
import AppViewList from "@/components/view-editor/ViewList.vue";
import AppSaleRowExtraSearchSettings from "./SaleRowExtraSearchSettings.vue";
import { AuthService } from "@/services";
import AppCustomTabList from "@/components/view-editor/CustomTabList.vue";
import AppDefaultEditTabList from "@/components/view-editor/DefaultEditTabList.vue";
import { getDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import AppCustomButtonList from "@/components/view-editor/CustomButtonList.vue";
import AppCustomReportButtonList from "@/components/view-editor/CustomReportButtonList.vue";

export default Vue.extend({
	data() {
		return {
			browse: null as null | Browse,
		};
	},
	computed: {
		currentLang(): string {
			return this.$i18n.locale;
		},
		browseName(): string {
			if (!this.browse) return "";
			return this.browse.Name.getTranslation(this.currentLang);
		},
		hasDefaultEditTabs(): boolean {
			if (!this.browse) return false;
			return getDefaultEditTabs(this.browse.ID).length > 0;
		},
		path(): IBreadCrumb[] {
			let path = [{
				to: "/settings/browse", value: this.$ct("views")
			}] as IBreadCrumb[];
			if (this.browse) {
				path.push({to: "", value: this.browse.Name.getTranslation(this.currentLang)});
			}
			return path;
		},
	},
	watch: {
		async "browse.Views"(newVal: View[], prevValue: View[]) {
			if (prevValue == null) {
				return;
			}
			let different = false;
			for (let i = 0; i < newVal.length; i++) {
				if (i != newVal[i].DisplayOrder) {
					different = true;
				}
				newVal[i].DisplayOrder = i;
			}
			if (different) {
				await ViewService.updateViews(newVal.filter(v=>v.UserID == AuthService.wfUser.ID));
			}
		}
	},
	methods: {
		AuthService() {
			return AuthService;
		},
		async deleteView(view: View) {
			await ViewService.deleteView(view);
			if (this.browse == null) {
				return;
			}
			this.browse.Views.splice(this.browse.Views.indexOf(view), 1);
		},
		createNewView(){
			if (!this.browse) return;
			this.$router.push(`/settings/browse/${this.browse.ID}/view/new`);
		},
		editClicked(view:View){
			if (!this.browse) return;
			this.$router.push(`/settings/browse/${this.browse.ID}/view/${view.ID}`);
		}
	},
	async created() {
		let browseID = parseInt(this.$route.params.id);
		this.browse = (await BrowseService.getBrowse(browseID)).browse;
	},
	components: {
		AppSearchSettingsEdit,
		AppViewList,
		AppSaleRowExtraSearchSettings,
		AppCustomTabList,
		AppDefaultEditTabList,
		AppCustomButtonList,
		AppCustomReportButtonList
	},
	i18nEx: {
		componentPrefix: "components.settings-browse"
	}
});
